<template>
  <div id="refunds">
    <PageTitle :title="$t('pos.refunds')" :subtitle="$t('pos.refunds_description')"></PageTitle>
    <div class="container">
      <Panel :showTitle="false">
        <Datatable entity="refund" :parameters="parameters"></Datatable>
      </Panel>
    </div>
  </div>
</template>
  
<script>
  import Datatable from "@/components/Datatable.vue";
  import PageTitle from '@/components/PageTitle.vue';

  export default {
    name: "Refunds",
    components: { Datatable, PageTitle },
    data() {
      return {
        parameters: {
          company: this.$route.query.company
        }
      };
    }
  };
</script>
